import { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';

export default function ResetPassword() {
  const [submissionMessage, setSubmissionMessage] = useState('');

  const onSubmit = (params, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);

    EcomEngineAPI.account.resetPassword(params).then((result) => {
      setSubmitting(false);

      if (result.status === 422) {
        setSubmissionMessage('User not found');
      }

      if (result.message) {
        setSubmissionMessage(result.message);
      }

      if (result.success) {
        setSubmissionMessage(result.success);
      }
    });
  };

  const formSchema = Yup.object().shape({
    username: Yup.string().required('Username or Email is required'),
  });

  return (
    <Formik
      initialValues={{
        username: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div className="row">
          <div className="col-12 col-lg-7 mx-auto">
            <div className="p-5 my-md-5 bg-white border space-y-4">
              <h2>Reset your password</h2>
              <div className="content text-small">
                <p>
                  If you are already registered but have forgotten your
                  password:
                </p>
                <ol>
                  <li>Enter your registered username or email.</li>
                  <li>
                    An email will be sent to your email address which contains
                    information about password recovery.
                  </li>
                  <li>
                    Please click the link in the email to reset your password.
                  </li>
                </ol>
              </div>

              {submissionMessage && (
                <div className="alert alert-danger alert-dismissible fade show text-small">
                  {submissionMessage}
                  <button
                    type="button"
                    className="close"
                    onClick={() => setSubmissionMessage(null)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}

              <Form className="needs-validation reset-password__form">
                <div className="form-group">
                  <label htmlFor="username">Username or Email</label>
                  <div>
                    <Field
                      name="username"
                      className="form-control"
                      id="username"
                      placeholder="Username or Email"
                    />
                  </div>
                  <ErrorMessage
                    className="text-danger text-small mt-1"
                    name="username"
                    component="div"
                    id="username_error"
                  />
                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary"
                  >
                    Reset password
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}
